import Illustration from './Illustration';
import DynamicIcon from './DynamicIcon';
import illuQuizParSujet from '../../assets/illustrations/fonctionnalites/quiz-par-sujet.svg?raw';
import illuMemoire from '../../assets/illustrations/fonctionnalites/memoire.svg?raw';
import illuFpt from '../../assets/illustrations/fonctionnalites/fonction-publique-territoriale.svg?raw';
import illuFpe from '../../assets/illustrations/fonctionnalites/fonction-publique-etat.svg?raw';
import illuPolice from '../../assets/illustrations/fonctionnalites/police-gendarmerie.svg?raw';
import illuPsycho from '../../assets/illustrations/fonctionnalites/tests-psychotechniques.svg?raw';
import illuSanteSocial from '../../assets/illustrations/fonctionnalites/sante-social.svg?raw';
import illuAtsem from '../../assets/illustrations/fonctionnalites/atsem.svg?raw';

// Violet foncé de la marque, comme le menu (pictogrammes docs/img/fonctionnalites-gestion-qcm-svg, 27/10/2026).
export const ILLU_COLOR = '#6d28d9';

// Icône de thématique (identifiant Lucide en base, scopes.icones) → dessin.
const SCOPE_ILLU = {
    'landmark': illuFpt, 'building-2': illuFpe, 'shield': illuPolice, 'puzzle': illuPsycho,
    'heart-pulse': illuSanteSocial, 'baby': illuAtsem, 'brain': illuMemoire, 'book-open': illuQuizParSujet,
};

/**
 * Pictogramme d'une thématique : dessin si l'icône en a un (sans icône : le livre), sinon l'icône Lucide d'origine
 * (`size` / `strokeWidth`).
 */
export default function ScopeIllustration({ icon, className = '', size = 28, strokeWidth = 1.8 }) {
    const svg = SCOPE_ILLU[icon || 'book-open'];
    if (svg) return <Illustration svg={svg} color={ILLU_COLOR} className={className} />;
    return <DynamicIcon name={icon} size={size} strokeWidth={strokeWidth} />;
}
